import React, { useEffect, useContext } from 'react';
import Dialog from '../../../../../BaseComponents/Dialog/EDDialog';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import { IOnStartWarningHookResult } from '../../Const/Rutiner';
import { RutinSettingsContext } from '../RutinAvailabilityContext/RutinAvailabilityContext';

interface IProps extends IOnStartWarningHookResult {
  isLoggedIn: boolean;
}

const OnStartWarningDialog: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const {
    rutinStartErrorDialogOpen,
    setRutinStartErrorDialogOpen,
    setHasRutinStartError,
  } = useContext(RutinSettingsContext);

  useEffect(() => {
    setRutinStartErrorDialogOpen(
      !props.loading &&
        !props.ok &&
        props.isLoggedIn &&
        Boolean(props.warningText)
    );
    setHasRutinStartError(
      !props.loading &&
        !props.ok &&
        props.isLoggedIn &&
        Boolean(props.warningText)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.loading, props.ok, props.isLoggedIn, props.warningText]);

  return (
    <Dialog
      open={rutinStartErrorDialogOpen}
      title={'Inställningar saknas'}
      onClose={() => setRutinStartErrorDialogOpen(false)}
      footerActions={[
        { label: 'Stäng', onClick: () => setRutinStartErrorDialogOpen(false) },
      ]}
      isErrorDialog
    >
      <EDTypography>{props.warningText}</EDTypography>
    </Dialog>
  );
};

export default OnStartWarningDialog;
